import * as config from "../config"
import getUserIdFromLocalStorage from "../getUserIdFromLocalStorage"
import getJamFilledCookie from "../getJamFilledCookie"

interface UserObject {
	name: string
	avatar: string
}

export default async function updateUser(
	updates: Partial<UserObject>,
): Promise<UserObject> {
	const res = await fetch(
		`${config.API_HOSTNAME}/api/user/${getUserIdFromLocalStorage()}`,
		{
			method: "PATCH",
			headers: {
				"content-type": "application/json",
				"jam-filled-cookie": getJamFilledCookie(),
				"jam-filled-userid": getUserIdFromLocalStorage(),
				"from-plugin": "true",
			},
			body: JSON.stringify(updates),
		},
	)
	const json = await res.json()

	window.localStorage.setItem("jamUser", JSON.stringify(json.user))

	return json.user
}
